/**
 * Telepost Api
 * Для авторизации зайти http://local.telepost.me/  В `/etc/hosts` добавить запись  ```sh 127.0.0.1 local.telepost.me ``` При авторизации добавть `Bearer` перед токеном         
 *
 * OpenAPI spec version: 2.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { SetCommentsRoleDto } from '../model/setCommentsRoleDto';
import { UnpromoteCommentsAdminDto } from '../model/unpromoteCommentsAdminDto';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class ChannelCommentsService {

    protected basePath = 'http://localhost/api';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Get banned users
     * 
     * @param channelId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public commentsGetBanned(channelId: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public commentsGetBanned(channelId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public commentsGetBanned(channelId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public commentsGetBanned(channelId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (channelId === null || channelId === undefined) {
            throw new Error('Required parameter channelId was null or undefined when calling commentsGetBanned.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.patch<any>(`${this.basePath}/channels/${encodeURIComponent(String(channelId))}/comments-banned`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get comments moderators list
     * 
     * @param channelId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public commentsModerators(channelId: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public commentsModerators(channelId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public commentsModerators(channelId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public commentsModerators(channelId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (channelId === null || channelId === undefined) {
            throw new Error('Required parameter channelId was null or undefined when calling commentsModerators.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<any>(`${this.basePath}/channels/${encodeURIComponent(String(channelId))}/comments-moderators`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Sync comments moderators list
     * 
     * @param channelId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public commentsModeratorsSync(channelId: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public commentsModeratorsSync(channelId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public commentsModeratorsSync(channelId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public commentsModeratorsSync(channelId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (channelId === null || channelId === undefined) {
            throw new Error('Required parameter channelId was null or undefined when calling commentsModeratorsSync.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<any>(`${this.basePath}/channels/${encodeURIComponent(String(channelId))}/sync-comments-moderators`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Change comments moderator role
     * 
     * @param SetCommentsRoleDto 
     * @param channelId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public commentsSetRole(SetCommentsRoleDto: SetCommentsRoleDto, channelId: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public commentsSetRole(SetCommentsRoleDto: SetCommentsRoleDto, channelId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public commentsSetRole(SetCommentsRoleDto: SetCommentsRoleDto, channelId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public commentsSetRole(SetCommentsRoleDto: SetCommentsRoleDto, channelId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (SetCommentsRoleDto === null || SetCommentsRoleDto === undefined) {
            throw new Error('Required parameter SetCommentsRoleDto was null or undefined when calling commentsSetRole.');
        }

        if (channelId === null || channelId === undefined) {
            throw new Error('Required parameter channelId was null or undefined when calling commentsSetRole.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.patch<any>(`${this.basePath}/channels/${encodeURIComponent(String(channelId))}/comments-change-role`,
            SetCommentsRoleDto,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Unban user
     * 
     * @param UnpromoteCommentsAdminDto 
     * @param channelId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public commentsUnban(UnpromoteCommentsAdminDto: UnpromoteCommentsAdminDto, channelId: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public commentsUnban(UnpromoteCommentsAdminDto: UnpromoteCommentsAdminDto, channelId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public commentsUnban(UnpromoteCommentsAdminDto: UnpromoteCommentsAdminDto, channelId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public commentsUnban(UnpromoteCommentsAdminDto: UnpromoteCommentsAdminDto, channelId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (UnpromoteCommentsAdminDto === null || UnpromoteCommentsAdminDto === undefined) {
            throw new Error('Required parameter UnpromoteCommentsAdminDto was null or undefined when calling commentsUnban.');
        }

        if (channelId === null || channelId === undefined) {
            throw new Error('Required parameter channelId was null or undefined when calling commentsUnban.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.patch<any>(`${this.basePath}/channels/${encodeURIComponent(String(channelId))}/comments-unban`,
            UnpromoteCommentsAdminDto,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Remove comments moderator from admins
     * 
     * @param UnpromoteCommentsAdminDto 
     * @param channelId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public commentsUnpromote(UnpromoteCommentsAdminDto: UnpromoteCommentsAdminDto, channelId: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public commentsUnpromote(UnpromoteCommentsAdminDto: UnpromoteCommentsAdminDto, channelId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public commentsUnpromote(UnpromoteCommentsAdminDto: UnpromoteCommentsAdminDto, channelId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public commentsUnpromote(UnpromoteCommentsAdminDto: UnpromoteCommentsAdminDto, channelId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (UnpromoteCommentsAdminDto === null || UnpromoteCommentsAdminDto === undefined) {
            throw new Error('Required parameter UnpromoteCommentsAdminDto was null or undefined when calling commentsUnpromote.');
        }

        if (channelId === null || channelId === undefined) {
            throw new Error('Required parameter channelId was null or undefined when calling commentsUnpromote.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.patch<any>(`${this.basePath}/channels/${encodeURIComponent(String(channelId))}/comments-unpromote`,
            UnpromoteCommentsAdminDto,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
